import { FundingProgramAbbreviation } from "@outschool/funding-programs-shared";
import { useLookupIP } from "@outschool/iplookup-client";
import { useSession } from "@outschool/ui-auth";
import Cookies from "js-cookie";

export enum FundingProgramFilterSource {
  ClassWallet = "ClassWallet",
  SearchFilters = "SearchFilters",
  LocationBased = "LocationBased",
}

export function useClassWalletSessionFundingProgramAbbr() {
  const { esaSessionData } = useSession();

  // if in a ClassWallet session, return the CW state
  if (!!esaSessionData?.shipping?.state) {
    return esaSessionData?.shipping?.state;
  }

  return null;
}

export function useSearchFiltersFundingProgramAbbr(searchFilters?: {
  fundingPrograms?: string[] | string | null;
}) {
  const fundingPrograms =
    typeof searchFilters?.fundingPrograms === "string"
      ? searchFilters?.fundingPrograms.split(",")
      : searchFilters?.fundingPrograms;
  if (!!fundingPrograms?.[0]) {
    return fundingPrograms?.[0];
  }

  return null;
}

export function useLocationBasedFundingProgramAbbr() {
  const { ipInfo } = useLookupIP();

  // if in the state of Florida, show the FL filter
  if (ipInfo?.subdivisions?.[0]?.isoCode === FundingProgramAbbreviation.FL) {
    return FundingProgramAbbreviation.FL;
  }

  return null;
}

export function useFundingProgramAbbr() {
  const classWalletFundingProgramAbbr =
    useClassWalletSessionFundingProgramAbbr();
  const floridaEMAFundingProgramAbbr =
    Cookies.get("floridaEMASession") === "true"
      ? FundingProgramAbbreviation.EMA
      : null;
  const locationBasedFundingProgramAbbr = useLocationBasedFundingProgramAbbr();

  return !!classWalletFundingProgramAbbr
    ? classWalletFundingProgramAbbr
    : !!floridaEMAFundingProgramAbbr
    ? floridaEMAFundingProgramAbbr
    : locationBasedFundingProgramAbbr;
}
